export default function Logo({ className = "", imgClass = "h-10 w-auto" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      <img
        src="/logo-katechese.png"
        alt="katechese.online"
        className={`${imgClass} object-contain`}
      />
    </div>
  );
}
